import React from 'react';
import '../CSS/style/style.css';

const Reservation = () => {
    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="reservation-container">
                <h2>예약안내, 주의사항</h2>

                <h3>🌿 예약 안내</h3>
                <span>
                    안녕하세요, 물조은펜션 입니다.<br/>
                    자연과 함께하는 편안한 휴식, 저희 펜션을 찾아주셔서 감사합니다.<br/>
                    아래 예약 안내 사항을 꼭 확인하시고, 즐거운 여행 계획에 도움이 되시길 바랍니다.
                </span>

                <h3>📅 예약 방법</h3>
                <span>
                    예약은 전화예약을 통해 가능합니다.<br/>
                    <b>010-2180-7979 / 010-7447-9222</b><br/>
                    예약 전 객실 정보와 요금표를 꼭 확인해주세요.
                </span>

                <h3>💳 입금 안내</h3>
                <span>
                    예약 후 2시간이내 입금해주셔야 예약이 확정됩니다. 2시간이 경과되면 자동 예약취소됩니다.<br/>
                    (단, 당일예약과 하루 전 예약은 1시간 이내에 입금 부탁드립니다.)<br/>
                    입금 후 입금자 성함을 문자로 꼭 보내주셔야 예약이 완료됩니다.<br/>
                    성함을 보내주시지 않으면 예약확인이 어렵습니다.<br/>
                    중복예약이 될 수 있으니 꼭 확인부탁드립니다.<br/>
                    입금자명이 예약자명과 다를 경우 꼭 미리 알려주세요.
                </span>

                <h3>농협은행 717096-52-18-6664 (윤정아)</h3>

                <hr style={{border: 'none', borderTop: '1px solid #ddd', margin: "50px 0"}}/>

                <h3>💰 요금안내</h3>
                <span>
                    - 주중 : 일요일 ~ 금요일<br/>
                    - 주말 : 토요일 및 공휴일 전날<br/>
                    - 준성수기 : 6월/9월<br/>
                    - 성수기 : 7월/8월<br/>
                    - 극성수기 : 7월 25일~8월16일<br/>
                    - 인원추가 : 1인당 성인 20,000원 /아동(만7세부터) 20,000원 / 미취학아동 없음
                </span>

                <table className="refund-table">
                    <thead>
                    <tr>
                        <td rowSpan={2}>객실<br/>(기준/최대)</td>
                        <td rowSpan={2}>특징</td>
                        <td colSpan={2}>비수기</td>
                        <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                        <td colSpan={2}>성수기<br/><span>(7월/8월)</span></td>
                        <td rowSpan={2}>극성수기<br/><span>(7월 25일 ~ 8월 16일)</span></td>
                    </tr>
                    <tr style={{backgroundColor: '#eee'}}>
                        <td>일~금</td>
                        <td>토요일/공휴일 전</td>
                        <td>일~금</td>
                        <td>토요일/공휴일 전</td>
                        <td>일~금</td>
                        <td>토요일/공휴일 전</td>
                    </tr>
                    </thead>
                    <tbody>
                    {[
                        {
                            room: '단풍 (2인 기준)',
                            price: ['90,000원', '120,000원', '90,000원', '180,000원', '180,000원', '250,000원', '250,000원']
                        },
                        {
                            room: '보리수 (2인 기준)',
                            price: ['90,000원', '120,000원', '90,000원', '180,000원', '180,000원', '250,000원', '250,000원']
                        },
                        {
                            room: '이팝 (4인 기준)',
                            price: ['120,000원', '170,000원', '120,000원', '220,000원', '220,000원', '300,000원', '300,000원']
                        },
                        {
                            room: '소나무 (4인 기준)',
                            price: ['120,000원', '170,000원', '120,000원', '220,000원', '220,000원', '300,000원', '300,000원']
                        },
                        {
                            room: '느릅 (6인 기준)',
                            price: ['170,000원', '220,000원', '170,000원', '300,000원', '300,000원', '380,000원', '380,000원']
                        },
                        {
                            room: '자귀 (8인 기준)',
                            price: ['300,000원', '420,000원', '300,000원', '420,000원', '420,000원', '550,000원', '550,000원']
                        },
                    ].map(({room, price}, idx) => (
                        <tr key={idx}>
                            <td data-label="객실">{room}</td>
                            <td data-label="특징">온돌방+침대</td>
                            <td data-label="비수기 일~금">{price[0]}</td>
                            <td data-label="비수기 토요일/공휴일 전">{price[1]}</td>
                            <td data-label="준성수기(6월/9월) 일~금">{price[2]}</td>
                            <td data-label="준성수기(6월/9월) 토요일/공휴일 전">{price[3]}</td>
                            <td data-label="성수기(7월/8월) 일~금">{price[4]}</td>
                            <td data-label="성수기(7월/8월) 토요일/공휴일 전">{price[5]}</td>
                            <td data-label="극성수기(7월 25일 ~ 8월 16일)">{price[6]}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>

                <h3>🌱 평상요금</h3>
                <span>
                    평일<br/>
                    - 4인 기준 5만원 (추가 시 1인당 10,000원)<br/><br/>

                    주말<br/>
                    - 3인 이하 5만원<br/>
                    - 4인 기준 6만원 (추가 시 1인당 10,000원)<br/>
                </span>

                <h3>🔥 숯불 요금</h3>
                <span>
                    - 숯+그릴+석쇠 제공 <br/>
                    - 2~4인 20,000원 / 5~8인 30,000원 (숯추가 10,000원 ~)
                </span>

                <h3>🌲 오토캠핑 요금</h3>
                <span>
                    - 60,000원 ~
                </span>

                <h3>🚗 픽업비용</h3>
                <span>
                    - 포항역 편도 : 50,000원
                    - 포항버스터미널 편도 : 60,000원
                </span>

                <hr style={{border: 'none', borderTop: '1px solid #ddd', margin: "50px 0"}}/>

                <h3>📌 주의사항</h3>
                <div className="service-desc">
                    <div className="service-desc2">
                        <h3>◎ 입·퇴실 안내</h3>
                        <span>
                            •입실 : 오후 3시 이후<br/>
                            •퇴실 : 오전 11시 이전<br/>
                            쾌적한 환경 유지를 위해 청소 시간이 필요하오니 시간 엄수 부탁드립니다.
                        </span>

                        <h3>◎ 객실 이용 안내</h3>
                        <span>
                            •모든 객실은 금연입니다. 흡연은 외부 지정된 장소를 이용해 주세요.<br/>
                            •인원 초과 및 무단 입실은 제한됩니다. (예약 인원 외 입실 시 추가요금 발생 또는 퇴실 조치될 수 있습니다.)<br/>
                            •반려동물 동반 입실은 불가합니다.
                        </span>

                        <h3>◎ 펜션 내 에티켓</h3>
                        <span>
                          •밤 10시 이후에는 다른 손님을 위해 실외 활동 및 소음 자제를 부탁드립니다. <br/>
                          •객실 내에서는 고기/생선 굽기, 기름 사용 요리 금지입니다. (야외 바비큐장을 이용해 주세요.)<br/>
                          •가구 및 집기류는 제자리에! 파손 시 변상 비용이 청구될 수 있습니다.
                        </span>
                        <br/><br/><br/>
                        <b>편안하고 즐거운 여행이 되실 수 있도록 언제나 최선을 다하겠습니다. 감사합니다.</b>
                    </div>

                    <div className="service-desc2">
                        <h3>◎ 바비큐장 이용</h3>
                        <span>
                          •이용 시간: 오후 5시 ~ 밤 10시<br/>
                          •그릴, 숯 제공은 사전 예약 부탁드립니다. (별도 요금 발생)<br/>
                          •날씨에 따라 운영이 제한될 수 있습니다.
                        </span>

                        <h3>◎ 화재 및 안전 주의</h3>
                        <span>
                            •펜션 내 불꽃놀이, 폭죽, 촛불 사용은 금지입니다.<br/>
                            •개인 화로 및 장작 사용 금지입니다.<br/>
                            •화재 예방을 위해 화기 사용 시 안전수칙 준수 부탁드립니다.
                        </span>

                        <h3>◎ 퇴실 시 협조사항</h3>
                        <span>
                            •사용한 식기류는 세척 후 정리 부탁드립니다.<br/>
                            •쓰레기는 분리수거하여 지정 장소에 버려주세요.<br/>
                            •퇴실 전 객실 내 조명, 냉·난방기기 전원 OFF 확인 부탁드립니다.
                        </span>
                    </div>
                </div>

                <hr style={{border: 'none', borderTop: '1px solid #ddd', margin: "50px 0"}}/>

                <h3>🌧️ 취소 및 환불 안내</h3>
                <span>
                    예약 취소 시 아래 환불 규정을 따릅니다.<br/>
                </span>

                <table className="refund-table">
                    <thead>
                    <tr>
                        <td>입금 후<br/>24시간 이내</td>
                        <td>입금 후<br/>24시간~9일전</td>
                        <td>이용일<br/>8일전</td>
                        <td>이용일<br/>7일전</td>
                        <td>이용일<br/>6일전</td>
                        <td>이용일<br/>5일전</td>
                        <td>이용일<br/>4일전</td>
                        <td>이용일<br/>3일전</td>
                        <td>이용일<br/>2일전</td>
                        <td>이용일<br/>1일전</td>
                        <td>이용일<br/>당일</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td data-label="입금 후 24시간 이내">전체금액<br/>100%환불</td>
                        <td data-label="입금 후 24시간~9일전">전체금액<br/>90%환불</td>
                        <td data-label="이용일 8일전">전체금액<br/>80%환불</td>
                        <td data-label="이용일 7일전">전체금액<br/>70%환불</td>
                        <td data-label="이용일 6일전">전체금액<br/>60%환불</td>
                        <td data-label="이용일 5일전">전체금액<br/>50%환불</td>
                        <td data-label="이용일 4일전">전체금액<br/>40%환불</td>
                        <td data-label="이용일 3일전">전체금액<br/>30%환불</td>
                        <td data-label="이용일 3일전">전체금액<br/>20%환불</td>
                        <td data-label="이용일 2일전">전체금액<br/>10%환불</td>
                        <td data-label="이용일 당일">전체금액<br/>0%환불</td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>
                    저희는 위와 같은 기준에 따라 우천 시 예약 취소 규정을 적용하고 있습니다.<br/>
                    • 일반적인 비/우천 시에는 기존 예약 취소 규정에 따라 취소 수수료가 부과됩니다.<br/>
                    ※ 단순 비 소식이나 흐린 날씨 등은 환불 사유에 해당하지 않습니다.<br/>
                    • 펜션 앞 다리가 침수되어 차량 진입이 불가능한 경우에는 현장 확인 후 100% 환불해 드립니다.<br/><br/>

                    기상 상황이 우려될 경우, 미리 연락 주시면 친절히 안내드리겠습니다.<br/>
                    안전하고 편안한 여행이 되시길 바랍니다. 감사합니다.
                </p>
            </div>
        </div>
    )
}

export default Reservation
